import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
var GlobalLoaderContext = /*#__PURE__*/ createContext(undefined);
export var GlobalLoaderProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var contextValue = {
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
    return /*#__PURE__*/ _jsx(GlobalLoaderContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useGlobalLoaderContext = function() {
    var context = useContext(GlobalLoaderContext);
    if (!context) {
        throw new Error("useGlobalLoaderContext must be used within an ErrorProvider");
    }
    return context;
};
